import { render, staticRenderFns } from "./KoPollutantsSub.vue?vue&type=template&id=50e67ae3"
import script from "./KoPollutantsSub.vue?vue&type=script&lang=js"
export * from "./KoPollutantsSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports